import { useMutation, useQueryClient } from '@tanstack/react-query';

import { gpsTrackerSelectKey } from '@components/modals/CreateEditAssetTrackingModal/services/useGPSTrackerSelectQuery';

import { apiClient } from '@services/apiClient';

import { gpsAssetsKey } from './useGPSAssetsQuery';
import { gpsTrackerKey } from './useGPSTrackersQuery';

const gpsTrackerDeleteFn = (gpsTrackerId: string | number) =>
  apiClient.delete(`${APP_API_URL_V2}fsd/gps-tracker/${gpsTrackerId}`);

export const useGPSTrackerDeleteMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: gpsTrackerDeleteFn,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [gpsTrackerKey({})[0]] });
      queryClient.invalidateQueries({ queryKey: [gpsTrackerSelectKey()[0]] });
      queryClient.invalidateQueries({ queryKey: [gpsAssetsKey({})[0]] });
    },
  });
};
